
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.5 38.5V16.3h-37v22.2z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M5.99 38.5l4.81-5.52h18.4l4.81 5.52M10.89 32.98V16.2M29.11 32.98V16.2M29.11 16.2V11a9.11 9.11 0 00-18.22 0v4.83M16.68 32.98v-10h6.64v10M11 11.11h18"}})])
          )
        }
      }
    